import { type UseQueryResult, useQuery } from 'react-query';
import { TransactionService } from '../../services/wealthlane-award-services';

const useGetCancelStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const cancelStatus = useQuery(
    ['getCancelStatus'],
    async () => {
      return await handleRequest(
        TransactionService.getApiAwardApiAppTransactionTransactionCancelStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.systemName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return cancelStatus;
};

export default useGetCancelStatus;
